<template>
  <div>
    <div class="menucontain">
      <table style="width: 100%">
        <tr>
          <td class="tdgridicon">
            <span @click="$refs.depositmodal.show()">
              <i
                class="fal fa-solid fa-piggy-bank tablinks"
                style="font-size: 30px; padding-top: 10px"
              ></i>
              <br />
              เติมเงิน
            </span>
          </td>
          <td class="tdgridicon">
            <span @click="$refs.withdrawmodal.show()">
              <i class="fal fa-coin tablinks"></i>
              <br />
              ถอนเงิน
            </span>
          </td>
          <td class="tdgridicon">
            <span @click="$refs.returnmodal.show()">
              <i
                class="fal fa-hand-holding-usd tablinks"
                style="font-size: 30px"
              ></i>
              <br />
              คืนยอดเสีย
            </span>
          </td>
          <td class="tdgridicon">
            <span @click="$refs.historymodal.show()">
              <i
                class="fal fa-history tablinks"
                style="font-size: 25px; padding-top: 14px"
              ></i>
              <br />
              ประวัติ
            </span>
          </td>
        </tr>
        <tr>
          <td class="tdgridicon">
            <span @click="$refs.friendmodal.show()">
              <i
                class="fal fa-user-friends tablinks"
                style="font-size: 25px; padding-top: 13px"
              ></i>
              <br />
              สร้างรายได้
            </span>
          </td>
          <td class="tdgridicon">
            <span @click="$refs.codemodal.show()">
              <i
                class="fal fa-code tablinks"
                style="font-size: 25px; padding-top: 14px"
              ></i>
              <br />
              <div style="font-size: 12px">CODE โปรโมชั่น</div>
            </span>
          </td>
          <!-- <td class="tdgridicon">
            <span>
              <i
                class="fal fa-calendar-alt tablinks"
                style="font-size: 25px; padding-top: 12px"
              ></i>
              <br />
              ฝากประจำ
            </span>
          </td> -->
          <td class="tdgridicon">
            <span @click="$refs.spinmodal.show()">
              <i
                class="fal fa-gem tablinks"
                style="font-size: 25px; padding-top: 12px"
              ></i>
              <br />
              กงล้อนำชัย
            </span>
          </td>
          <td class="tdgridicon">
            <a :href="WebSetting.lineId">
              <i
                class="fal fa-user tablinks"
                style="font-size: 25px; padding-top: 12px"
              ></i>
              <br />
              ติดต่อเจ้าหน้าที่
            </a>
          </td>  
        </tr>
        <!-- <tr>
          <td class="tdgridicon">
            <span @click="$refs.faceshare.show()">
              <i 
                 class="fal fa-share tablinks"
                 style="font-size: 25px; padding-top: 12px"
              ></i>
              <br />
              faceshare
            </span>
          </td>
          <td class="tdgridicon">
            <span @click="$refs.sood.show()">
              <i 
                 class="fal fa-robot tablinks"
                 style="font-size: 25px; padding-top: 12px"
              ></i>
              <br />
              สูตรจาวิส
            </span>
          </td>
        </tr> -->
      </table>
    </div>
    <CodeModal ref="codemodal" />
    <DepositModal ref="depositmodal" />
    <FriendModal ref="friendmodal" />
    <HistoryModal ref="historymodal" />
    <ReturnModal ref="returnmodal" />
    <SpinModal ref="spinmodal" />
    <WithdrawModal ref="withdrawmodal" />
    <PromotionModal ref="promotionmodal" />
    <Faceshare ref="faceshare" />
    <Sood ref="sood" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CodeModal from "@/components/modal/code.vue";
import DepositModal from "@/components/modal/DepositModal.vue";
import FriendModal from "@/components/modal/FriendModal.vue";
import HistoryModal from "@/components/modal/HistoryModal.vue";
import ReturnModal from "@/components/modal/ReturnLose.vue";
import SpinModal from "@/components/modal/SpinModal.vue";
import WithdrawModal from "@/components/modal/WithdrawModal.vue";
import PromotionModal from "@/components/modal/PromotionModal.vue";
import Faceshare from "@/components/modal/Faceshare.vue";
import Sood from "@/components/modal/Sood.vue";
export default {
  name: "menu-component",
  components: {
    PromotionModal,
    CodeModal,
    DepositModal,
    FriendModal,
    HistoryModal,
    ReturnModal,
    SpinModal,
    WithdrawModal,
    Faceshare,
    Sood,
  },
  computed: {
    ...mapGetters(["WebSetting"]),
  },
  // methods: {
  //   openTacticWeb() {window.open(
  //         `https://javissood.com/`,
  //         "_blank"
  //       );
  //     }
  // }
};
</script>

<style></style>
